
















// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import { mapActions, mapGetters } from "vuex";

// Components
import SelectTag from "@/shared/components/select.tag.component.vue";
import Btn, { BtnColor, BtnWidth } from "@/shared/components/btn.component.vue";
import TopBar from "@/shared/components/TopBar.component.vue";
import ItemThumb from "@/shared/components/item-thumb.component.vue";
import SpotlightText, {
  SpotlightTextColor,
} from "@/shared/components/SpotlightText.component.vue";
import Modal, {
  ModalTitleColor,
} from "@/shared/components/Modal.component.vue";
import Field from "@/shared/components/field.component.vue";
import FieldSet from "@/shared/components/field-set.component.vue";
import CheckIcon, {
  CheckIconColor,
} from "@/shared/components/CheckIcon.component.vue";
import Icon, { IconEnum } from "@/shared/components/icon.component.vue";
import Input, {
  InputType,
  InputStyle,
  InputLabelColor,
} from "@/shared/components/input.component.vue";
import TextArea from "@/shared/components/text-area.component.vue";
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
  FlatSelectorTextSize,
} from "@/shared/components/FlatSelectorText.component.vue";
import EditFiscalDataModal from '@/manager/client/views/clientEditModal/index.vue';
import BillList from "@/manager/billing/views/bill-list/index.vue";
import ChoosePaymentMethod from '@/client/budget/views/acceptance/choose-payment-method/index.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import FlatSelectorSwitch from '@/shared/components/flat-selector-switch.component.vue';

// Third party
import dayjs from 'dayjs';
import 'dayjs/locale/es';

// Filters
import formatPhone from "@/shared/filters/formatPhone.filter.ts";
import formatDate from "@/shared/filters/formatDate.filter.ts";

// Mixins
import NotificationMessage from "@/shared/mixins/notificationMessage.mixin.ts";
import ErrorMixin from "@/shared/mixins/error.mixin.ts";
import SearchMixin from "@/shared/mixins/search.mixin.ts";
import WithPagination from "@/shared/mixins/withPagination.mixin.ts";
import SettingsMixin from "@/shared/mixins/settings.mixin.ts";

// Constants
import Assets from "@/constants/assets";
import Constants from "@/constants/constants";

// Models
import { Client } from "@/manager/client/client.model";
import {
  AcquiredCourses,
  ClientProduct,
  ClientParticipants,
} from "@/manager/client/acquiredCourses.model";
import {
  Budget,
} from '@/manager/budget/models/budget.model';

import {
  BudgetPaymentMethod,
  BudgetPaymentStatus,
  BudgetPaymentStatusLiteral,
  BudgetCommunicationStatus,
  BudgetCommunicationStatusListeral,
  BudgetAlert,
  BudgetAlertLiteral,
} from '@/manager/budget/models/budget.model';

// Services
import UtilsService from "@/core/services/utils.service";
import {
  ConvocationService,
  TypeOfProduct,
} from "@/manager/convocation/convocation.service";
import { TypeOfProductLiteral } from "@/manager/product/models/product.model";
import ButtonSwitch, {
  SwitchActiveColor,
  ButtonSwitchPredefinedStyle,
} from "@/shared/components/button-switch.component.vue";
import pluralizeFilter from "@/shared/filters/pluralize.filter.ts";
import Tooltip, {
  TooltipColor,
  TooltipAlign,
} from "@/shared/components/Tooltip.component.vue";
import NoteItemClient from "@/manager/client/views/clientEdit/noteItemClient/noteItemClient.view.vue";
import uppercase from "@/shared/filters/uppercase.filter.ts";
import ExpansionPanel from "@/shared/components/expansion.panel.component.vue";
import MenuElement, {
  MenuElementBgColor,
  MenuElementBgColorHover,
  MenuElementSize,
} from '@/shared/components/menu-element.component.vue';
import FloatMenu, {
  FloatMenuPosition,
} from '@/shared/components/float-menu.component.vue';
import BillingService from '@/manager/billing/billing.service';
import { PurchaseService } from '@/manager/purchase/purchase.service';
import FlatSelectorTextMultiple from "@/shared/components/FlatSelectorTextMultiple.component.vue";
import Spinner from "@/shared/components/Spinner.component.vue";
import { purchase } from "@/clickbuy/purchase/store";
import Endpoints from "@/constants/endpoints";
import { ParticipantListType } from "@/manager/convocation/views/convocationDetail/convocationRow/convocationRow.view.vue";
import BudgetService from "@/manager/budget/budget.service";


interface MixinInterface
  extends NotificationMessage,
  ErrorMixin,
  SearchMixin,
  SettingsMixin { }

@Component({
  components: {
    TopModal,
    SelectTag,
    BillList,
    Btn,
    ButtonSwitch,
    Input,
    Field,
    FieldSet,
    CheckIcon,
    Icon,
    ExpansionPanel,
    MenuElement,
    FloatMenu,
    ItemThumb,
    TopBar,
    SpotlightText,
    Spinner,
    TextArea,
    Modal,
    FlatSelectorSwitch,
    FlatSelectorText,
    FlatSelectorTextMultiple,
    Tooltip,
    NoteItemClient,
    EditFiscalDataModal,
    ChoosePaymentMethod,
  },
  computed: {
    ...mapGetters({
      getClient: "getClient",
      getProfile: "getProfile",
      getConvocationNote: 'getConvocationNote',
      getParticipantNote: 'getParticipantNote',
      acquiredCoursesList: "acquiredCoursesList",
      getPurchaseList: 'getPurchaseList',
      getProcedencyList: "procedencyList",
      getPermissions: 'getPermissions',
      currentBudget: 'getCurrentBudgetAcceptance',
      isCardMethodSelected: 'isCardMethodSelectedInCurrentBudgetAcceptance',
      isDirectDebitMethodSelected:
        'isDirectDebitMethodSelectedInCurrentBudgetAcceptance',
    }),
  },
  methods: {
    ...mapActions({
      // fetchEmployeeList: 'fetchEmployeeList',
      setCurrentBudget: 'setCurrentBudgetAcceptance',
    }),
    updateComment(commentId: any, comment: any) {
      this.$emit('note-item-update', commentId, comment);
    }
  },
  filters: {
    formatPhone,
    formatDate,
    pluralizeFilter,
    uppercase,
  },
})
export default class ClientEdit extends Mixins<MixinInterface>(
  NotificationMessage,
  ErrorMixin,
  SearchMixin,
  SettingsMixin
) {
  @Prop() private id!: string;
  private constants = Constants;
  private btnWidth = BtnWidth;
  private tooltipColor = TooltipColor;
  private btnColor = BtnColor;
  private assets = Assets;
  private inputType = InputType;
  private inputStyle = InputStyle;
  private inputLabelColor = InputLabelColor;
  private checkIconColor = CheckIconColor;
  private modalTitleColor = ModalTitleColor;
  private budgetCommunicationStatus = BudgetCommunicationStatus;
  private lastNoteTyped: string = "";
  private getClient!: any;
  private getProfile!: any;
  private acquiredCoursesList!: any;
  private addFiscalDataModalOpened = false;
  private editFiscalDataModalOpened = false;
  private addClientPaymentModalOpened = false;
  private editingFiscalData = false;
  private coursesList:any;
  private eventsList:any;
  private conferencesList:any;
  private getProcedencyList!: any;
  private getConvocationNote!: any;
  private getParticipantNote!: any;
  private client = new Client();
  private isDeleteModalOpened = false;
  private addObservationBudgetNoteModalOpened = false;
  private iconEnum = IconEnum;
  private alertDisplace = false;
  private updated = false;
  private nifOrPassportMask = "";
  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private flatSelectorTextSize = FlatSelectorTextSize;
  private gender = this.genderOptions[0];
  private timeSwitchSelected = this.constants.switchGenerals;
  private show = "generals";
  private origin = "";
  private procedencyOptionsRequest: any = [];
  private clientTagList: any = [];
  private clientCountryList: any = [];
  private clientProvinceList: any = [];
  private clientPostalCodeList: any = [];
  private required = "Campo requerido";
  private notes = "";
  private activeNote = "";
  private activePurchaseNote = "";
  private activeBudgetNote = "";
  private procedencyOption: any = {
    value: "0",
    label: "",
  };
  private countryOption: any = {
    value: "0",
    label: "",
  };
  private provinceOption: any = {
    value: "0",
    label: "",
  };
  private postalCodeOption: any = {
    value: "0",
    label: "",
  };
  private literals = {
    section1: "Datos personales",
  };
  public error = {
    user: {
      firstName: "",
      lastName: "",
      email: "",
      gender: "",
      procedencyOption: "",
      cp: "",
      profile: {
        phone: "",
      },
    },
  };
  private ordering?: string;
  private updateKey?: any = 0;
  private menuElementBgColor = MenuElementBgColor;
  private menuElementBgColorHover = MenuElementBgColorHover;
  private floatMenuPosition = FloatMenuPosition;
  private deleteClientModalOpened = false;
  private addObservationClientModalOpened = false;
  private modalNoteEmpty = false;
  private modalNote = "";
  private addCommentModalOpened = false;
  private modalCommentEmpty = false;
  private modalComment = "";
  private notifications = [];
  private employeeList = [];
  private employeeEmails = [];
  private yetOpenedCollapsableInfo = false;
  private globalConferencias = false;
  private globalCursos = false;
  private globalEventos = false;
  private globalPresupuestos = false;
  private globalPurchase = false;
  private listType: ParticipantListType = ParticipantListType.ParticipantList;
  private fiscalDataEdit!: any;
  private clientPayments!: any;
  private mailCodificados = { id: 0, text: "Codificados" }
  private mailCompletos = { id: 1, text: "Completos" }
  private mailSwitchSelected = this.mailCodificados
  private zipcodes:any;
  private setCurrentBudget!:any;
  private currentBudget?: any;
  private isCardMethodSelected!: any;
  private isDirectDebitMethodSelected!: any;
  private note:any;



  @Watch("client.user.profile.nif")
  private watchNifOrPassport(newVal: string, oldVal: string) {
    this.nifOrPassportMask = UtilsService.setNifMask(
      newVal,
      this.nifOrPassportMask
    );
    // const passport = 'AAA######?A';
  }

  @Watch("gender")
  private watchGender(newVal: any, oldVal: any) {
    (this.client.user as any).profile.gender = newVal.value;
  }

  @Watch("procedencyOption")
  private watchProcedency(newVal: any, oldVal: any) {
    (this.client.procedency as any) = newVal.value;
  }

  @Watch("provinceOption")
  private watchProvince(newVal: any, oldVal: any) {
    (this.client.user.profile.state as any) = newVal.value;
  }

  @Watch("postalCodeOption")
  private watchPostalCde(newVal: any, oldVal: any) {

    (this.client.user.profile.postalCode as any) = newVal.value;
  }

  // @Watch("participant.checked")
  // private watchConfirmation(newVal: boolean, oldVal: boolean) {
  //   this.patchParticipant({ confirmation: newVal });
  // }

  @Watch('client.user.profile.phone')
  private watchPhone(newVal: any, oldVal: any) {
    if (!newVal) {
      (this.client.user as any).profile.phone = '+';
    } else if (newVal.charAt(0) != '+') {
      newVal = '+' + newVal;
      (this.client.user as any).profile.phone = newVal;
    } else {
      (this.client.user as any).profile.phone = newVal;
    }
  }

  get passportDniError() {
    try {
      const field = (this.client.user as any).profile.nif || "";
      if (!field || this.client.user.profile.state == 'Extranjero') {
        return;
      }
      // dni| nif
      const isDni = UtilsService.validateDni(field);
      const isNie = UtilsService.validateNie(field);
      const isPassport = /^[a-z]{3}[0-9]{6}[a-z]?$/i.test(
        (this.client.user as any).profile.nif
      ); // passport

      const valid = isDni || isNie || isPassport;
      return valid ? "" : "DNI, NIE o Pasaporte no Válido";
    } catch (_) {
      return;
    }
  }

  get lastNameInvalid() {
    const field = (this.client.user as any).lastName || "";
    return field ? "" : this.required;
  }
  get nameInvalid() {
    const field = (this.client.user as any).firstName || "";
    return field ? "" : this.required;
  }
  get cpInvalid() {
    if (this.client.status == 1) {
      return "";
    } else {
      const field = (this.client.user as any).profile.postalCode || "";
      if (field.trim().length < 5) {
        return "Campo incompleto"
      }
      return field ? "" : this.required;
    }
  }
  get genderInvalid() {
    if (this.client.status == 1) {
      return "";
    } else {
      const field = this.gender || "";
      return (field && field.value != 0) ? "" : this.required;
    }
  }
  get procedencyOptionInvalid() {
    if (this.client.status == 1) {
      return "";
    } else {
      const field = this.procedencyOption || "";
      return field ? "" : this.required;
    }
  }

  get emailError() {
    try {
      const field = (this.client.user as any).email || "";
      if (!field) {
        return this.required;
      }
      const valid = UtilsService.checkValidEmail(field);
      return valid ? "" : "correo no válido";
    } catch (_) {
      return this.required;
    }
  }

  get formInvalid() {
    return (
      !!this.emailError ||
      !!this.passportDniError ||
      !!this.lastNameInvalid ||
      !!this.nameInvalid ||
      !!this.cpInvalid ||
      !!this.genderInvalid ||
      !!this.procedencyOptionInvalid
    );
  }

  private created() {
    this.getSearchParam()
    if (this.id !== "new") {
      this.fetchClient();
      this.fetchAcquiredCourses(true);
    } else {
      this.fetchPostalCodeList(null);
    }
    this.fetchProcedency();
    this.fetchTagList();
    this.fetchProvinceList();
    this.fetchCountryList();
    this.fetchEmployeeEmails();
    this.fetchClientPayment(this.mailCodificados.id)
    if (!this.searchString) {
      this.timeFilterChanged({ "id": 1 });
    }
    this.zipcodes = this.assets.zipCodesJson
  }

  get userBackUrl() {
    const url = window.location.origin + "/api/admin/users/user/" + (this.client.user as any).id + "/change"
    return url
  }


  get isEdit() {
    const u = this.updated;
    const id = this.$router.currentRoute.params.id;
    return id !== "new";
  }

  get profileAvatar() {
    let avatar = this.assets.defaultAvatar;
    if (this.getProfile.profile && this.getProfile.profile.avatar !== null) {
      avatar = this.getProfile.profile.avatar;
    }
    return avatar;
  }

  get avatar() {
    let avatar = this.assets.defaultAvatar;
    if ((this.client.user as any).profile.avatar) {
      avatar = (this.client.user as any).profile.avatar;
    }
    return avatar;
  }

  get phone() {
    let phone = " ";
    const clientPhone = (this.client.user as any).profile.phone;
    if (clientPhone) {
      phone = clientPhone.toString();
    }
    return phone;
  }

  get nif() {
    let nif = " ";
    const clientNif = (this.client.user as any).profile.nif;
    if (clientNif) {
      nif = clientNif.toString();
    }
    return nif;
  }

  get email() {
    let email = " ";
    const clientEmail = (this.client.user as any).email;
    if (clientEmail) {
      email = clientEmail.toString();
    }
    return email;
  }

  get fullName() {
    let name = `${(this.client.user as any).firstName} ${(this.client.user as any).lastName}`;

    if ((this.client.user as any).profile.isDniFake) {
      name += '(DNI FALSO)';
    }
    if (name === " ") {
      name = "Nuevo cliente";
    }
    return name;
  }

  get nameBillFilter() {
    let clientId = `${(this.client.user as any).id}`;
    return clientId;
  }

  get observationTitle() {
    let title = "Añadir observación";
    if (this.isEdit) {
      title = "Observación";
    }
    return title;
  }

  get deactivateButtonText() {
    const active = (this.client.user as any).isActive;
    let text = "Desactivar";
    if (!active) {
      text = "Activar";
    }
    return text;
  }

  get hasAcquiredCourses() {
    return this.acquiredCoursesList.numberOfConvocations > 0;
  }

  get showAcquiredCourses() {
    return this.hasAcquiredCourses && this.isEdit;
  }

  get convocationsTitle() {
    const numberOfConvocations = this.acquiredCoursesList.numberOfConvocations;
    let title = `${numberOfConvocations} convocatorias`;
    if (numberOfConvocations === 1) {
      title = "1 convocatoria";
    }
    return title;
  }

  get purchasesTitle() {
    const numberOfPurchases = this.acquiredCoursesList.purchases.length;
    let title = `${numberOfPurchases} compras`;
    if (numberOfPurchases === 1) {
      title = "1 compra";
    }
    return title;
  }

  get budgetsTitle() {
    const numberOfBudgets = this.acquiredCoursesList.budgets.length;
    let title = `${numberOfBudgets} altas`;
    if (numberOfBudgets === 1) {
      title = "1 alta";
    }
    return title;
  }

  get fiscalDataExtensionsTitle() {
    const numberOfFiscalDataExtensions = this.acquiredCoursesList.fiscalDataExtensions.length;
    let title = `${numberOfFiscalDataExtensions} direcciones de facturación`;
    if (numberOfFiscalDataExtensions === 1) {
      title = "1 dirección de facturación";
    }
    return title;
  }

  get pagoAplazadoTitle() {
    if (this.clientPayments) {
      const numberOfClientPayments = this.clientPayments.length;
      let title = `${numberOfClientPayments} datos de pago aplazado`;
      if (numberOfClientPayments === 1) {
        title = "1 dato de pago aplazado";
      }
      return title;
    }
    return ''
  }

  get clientBillsTitle() {
    // const numberOfFiscalDataExtensions = this.acquiredCoursesList.fiscalDataExtensions.length;
    // let title = `${numberOfFiscalDataExtensions} direcciones de facturación`;
    // if (numberOfFiscalDataExtensions === 1) {
    //   title = "1 dirección de facturación";
    // }
    let title = 'Facturas del cliente'
    return title;
  }

  get timeFilter(): any[] {
    return [
      this.constants.switchGenerals,
      this.constants.switchConvocations,
      this.constants.switchPurchases,
      this.constants.switchBudgets,
      this.constants.switchBills,
      this.constants.switchFiscalDataExtension,
      this.constants.switchPaymentMethods,
    ];
  }

  get iconTlpColor() {
    let color:any = this.checkIconColor.Gold;
    if (this.client.oldTopLevelPack) {
      color = this.checkIconColor.GoldDark;
    }
    if (this.client.topLevelPack) {
      if (this.client.tlp) {
        color = this.client.tlp.color;
      }
    } else {
      color = '#d1d1d1';
    }
    return color;
  }

  get iconPwpColor() {
    let color:any = this.checkIconColor.Gold;
    if (this.client.powerPack) {
      if (this.client.pwp) {
        color = this.client.pwp.color;
      }
    } else {
      color = '#d1d1d1';
    }
    return color;
  }

  get genderOptions() {
    return [
      {
        value: 0,
        label: "Sin especificar",
      },
      {
        value: 1,
        label: "Masculino",
      },
      {
        value: 2,
        label: "Femenino",
      },
    ];
  }

  private fetchEmployeeEmails() {
    this.$store.dispatch("fetchEmployeeList").then((res) => {
      this.employeeList = res.results.map((e: any) => {
        return {
          name: e.user.fullName,
          email: e.user.email,
          id: e.user.id,
        };
      });
    });
  }

  get modalCommentPlaceholder() {
    let placeholder =
      "Comparte algún comentario con tus compañeros sobre la nota de esta alta...";
    if (this.modalCommentEmpty) {
      placeholder = "Este campo no puede estar vacío...";
    }
    return placeholder;
  }

  get genderOptionsSelected() {
    return this.genderOptions[0];
  }

  get procedencySelected() {
    const procedencyId = this.client.procedency;
    let result = {};
    if (procedencyId) {
      result = this.procedencyOptionsRequest.find((option: any) => {
        return option.value === procedencyId;
      });
    }
    return result;
  }

  get provinceSelected() {
    const provinceId = this.client.user.profile.state;

    let result = {};
    if (provinceId) {
      result = this.clientProvinceList.find((option: any) => {
        return option.value === provinceId;
      });
      this.fetchPostalCodeList(provinceId);
    }
    return result;
  }

  get countrySelected() {
    const countryId = this.client.user.profile.country;
    let result = {};
    if (countryId) {
      result = this.clientCountryList.find((option: any) => {
        return option.value === countryId;
      });
    }

    return result;
  }

  private updateCP(province: any) {
    this.fetchPostalCodeList(province.value);
  }

  get postalCodeSelected() {
    const postalCodeId = this.client.user.profile.postalCode;
    let result = {};
    if (postalCodeId) {
      result = this.clientPostalCodeList.find((option: any) => {
        return option.value === postalCodeId;
      });
    }
    return result;
  }

  get mailFilter(): any[] {
    return [this.mailCodificados, this.mailCompletos];
  }

  private budgetStateTooltip(communicationStatus:any){
    if (communicationStatus == BudgetCommunicationStatus.Accepted) {
      return MenuElementBgColor.Primary;
    } else if (communicationStatus == BudgetCommunicationStatus.Dispatched) {
      return MenuElementBgColor.Secondary;
    } else if (communicationStatus == BudgetCommunicationStatus.Rejected) {
      return MenuElementBgColor.Red;
    }
    return MenuElementBgColor.Secondary;
  }

  private sendAcceptanceEmail(budgetId:any) {
    BudgetService.sendAcceptanceEmail(budgetId).then((res) => {
      this.onSucess();
    }, this.onError);
  }

  private sendValidationEmail(budgetId:any) {
    BudgetService.sendValidationEmail(budgetId).then(
      this.onSucess,
      this.onError
    );
  }

  private sendBudgetEmail(purchaseId:any, communicationStatus:any) {
    if (communicationStatus == BudgetCommunicationStatus.Adjust) {
      this.sendValidationEmail(purchaseId);
    } else {
      this.sendAcceptanceEmail(purchaseId);
    }
  }

  private mailFilterChanged(option: any) {
    if (option.id === this.mailCodificados.id) {
      this.mailSwitchSelected = this.mailCodificados;
      this.fetchClientPayment(this.mailCodificados.id)
    } else if (option.id === this.mailCompletos.id) {
      this.mailSwitchSelected = this.mailCompletos;
      this.fetchClientPayment(this.mailCompletos.id)
    }

  }

  private isConference(clientProduct: ClientProduct) {
    return clientProduct.typeOfProduct === TypeOfProduct.Conference;
  }

  private acquiredCourseType(clientProduct: ClientProduct): string {
    let type = "Sin indicar";
    if (clientProduct.typeOfProduct) {
      type = TypeOfProductLiteral[clientProduct.typeOfProduct];
    }
    return type;
  }

  private acquiredCourseTitle(clientProduct: ClientProduct): string {
    let title = "";
    if (clientProduct.typeOfProduct === TypeOfProduct.Course) {
      if (clientProduct.level) {
        title = `Nivel ${clientProduct.level}`;
      } else {
        title = "Especialización";
      }
    }
    return title;
  }

  private saveHandleClick() {
    this.sendForm();
  }

  private saveHandleClickIcons() {
    this.sendFormIcon();
  }

  private deactivateHandleClick() {
    const active = (this.client.user as any).isActive;
    this.patchClient({ user: { isActive: !active } });
    (this.client.user as any).isActive = !active;
  }

  private DeleteHandleClick() {
    this.deleteModalToggle(true);
  }

  private fetchClient() {
    this.$store.dispatch("fetchClient", { id: this.id }).then((res) => {
      res.tag = res.tag.map((e: any) => {
        return { ...e, active: true };
      });
      this.client = res;
      const note = this.client.note as any;
      if (note !== null && note !== undefined) {
        this.lastNoteTyped = note.note;
      }
      this.gender = this.getGenderOption(
        (this.client.user as any).profile.gender
      );
    });
  }

  private getGenderOption(value: number) {
    let result = this.genderOptions.find((obj: any) => {
      return obj.value === value;
    });
    if (!result) {
      result = this.genderOptions[0];
    }
    return result;
  }

  // La carga de cursos adquiridos puede fallar (403, red, 5xx). Sin este
  // catch la promesa quedaba rechazada sin tratar y la pantalla se quedaba
  // muda, con los datos a medias.
  private notifyAcquiredCoursesError() {
    this.showNotification(
      "No se han podido cargar los datos del cliente",
      SpotlightTextColor.Error,
    );
  }

  private fetchAcquiredCourses(first?: any) {
    this.$store
      .dispatch("fetchAcquiredCoursesList", { id: this.id })
      .then((res) => {
        if (!this.searchString) {
          if (first) {
            this.timeFilterChanged({ "id": 1 });
          } else {
            this.timeFilterChanged({ "id": 2 });
          }
        } else {
          this.setShowParam()
        }
        this.yetOpenedCollapsableInfo = true;
        this.updateKey++;
      })
      .catch(() => {
        this.notifyAcquiredCoursesError();
      });
  }

  private fetchCoursesList() {
    this.$store
      .dispatch("fetchAcquiredCoursesList", { id: this.id })
      .then((res) => {
        if (!this.searchString) {
          this.timeFilterChanged({ "id": 1 });
          this.timeFilterChanged({ "id": 2 });
        } else {
          this.setShowParam()
        }
        this.updateKey++;
      })
      .catch(() => {
        this.notifyAcquiredCoursesError();
      });
  }

  private fetchBudgetsList() {
    this.$store
      .dispatch("fetchAcquiredCoursesList", { id: this.id })
      .then((res) => {
        if (!this.searchString) {
          this.timeFilterChanged({ "id": 4 });
        } else {
          this.setShowParam()
        }
        this.updateKey++;
      })
      .catch(() => {
        this.notifyAcquiredCoursesError();
      });
  }

  private fetchFiscalDataExtensionsList() {
    this.$store
      .dispatch("fetchAcquiredCoursesList", { id: this.id })
      .then((res) => {
        if (!this.searchString) {
          this.timeFilterChanged({ "id": 5 });
        } else {
          this.setShowParam()
        }
        this.updateKey++;
      })
      .catch(() => {
        this.notifyAcquiredCoursesError();
      });
  }

  private fetchPurchasesList() {
    this.$store
      .dispatch("fetchAcquiredCoursesList", { id: this.id })
      .then((res) => {
        if (!this.searchString) {
          this.timeFilterChanged({ "id": 3 });
        } else {
          this.setShowParam()
        }
        this.updateKey++;
      })
      .catch(() => {
        this.notifyAcquiredCoursesError();
      });
  }

  private pushQueryStrings() {
    const productType = "";
    const search = this.searchString;
    this.$router.push({
      name: this.$route.name,
      query: {
        product_type: productType,
        search,
      },
    });
  }

  get noteListTransitionName() {
    let transitionName = 'note-list';
    if (!this.yetOpenedCollapsableInfo) {
      transitionName += '-disabled';
    }
    return transitionName;
  }

  private getSearchParam() {
    const search = this.$route.query.search;
    this.searchString = search;
  }

  private setShowParam() {
    if (this.searchString === this.constants.switchGenerals.requestName) {
      this.ordering = "-initial_date";
      this.timeSwitchSelected = this.constants.switchGenerals;
      this.show = "generals";
    } else if (this.searchString === this.constants.switchConvocations.requestName) {
      this.ordering = "-initial_date";
      this.timeSwitchSelected = this.constants.switchConvocations;
      this.show = "convocations";
      this.coursesList = this.acquiredCoursesList.products.filter(
        (product: any) => {
          return product.typeOfProduct == 2;
        }
      );
      setTimeout(() => {
        this.updateKey++;
      }, 5000);
      this.eventsList = this.acquiredCoursesList.products.filter(
        (product: any) => {
          return product.typeOfProduct == 3;
        }
      );
      this.conferencesList = this.acquiredCoursesList.products.filter(
        (product: any) => {
          return product.typeOfProduct == 1;
        }
      );
    } else if (this.searchString === this.constants.switchPurchases.requestName) {
      this.timeSwitchSelected = this.constants.switchPurchases;
      this.show = "purchases";
    } else if (this.searchString === this.constants.switchBudgets.requestName) {
      this.timeSwitchSelected = this.constants.switchBudgets;
      this.show = "budgets";
    } else if (this.searchString === this.constants.switchFiscalDataExtension.requestName) {
      this.timeSwitchSelected = this.constants.switchFiscalDataExtension;
      this.show = "fiscalDataExtensions";
    } else if (this.searchString === this.constants.switchBills.requestName) {
      this.timeSwitchSelected = this.constants.switchBills;
      this.show = "clientBills";
    } else if (this.searchString === this.constants.switchPaymentMethods.requestName) {
      this.timeSwitchSelected = this.constants.switchPaymentMethods;
      this.show = "pagoAplazado";
    }
  }

  private timeFilterChanged(option: any) {
    this.ordering = undefined;


    if (option.id === this.constants.switchGenerals.id) {
      this.ordering = "-initial_date";
      this.timeSwitchSelected = this.constants.switchGenerals;
      this.show = "generals";
    } else if (option.id === this.constants.switchConvocations.id) {
      this.ordering = "-initial_date";
      this.timeSwitchSelected = this.constants.switchConvocations;
      this.show = "convocations";
      this.coursesList = this.acquiredCoursesList.products.filter(
        (product: any) => {
          return product.typeOfProduct == 2;
        }
      );
      setTimeout(() => {
        this.updateKey++;
      }, 5000);
      this.eventsList = this.acquiredCoursesList.products.filter(
        (product: any) => {
          return product.typeOfProduct == 3;
        }
      );
      this.conferencesList = this.acquiredCoursesList.products.filter(
        (product: any) => {
          return product.typeOfProduct == 1;
        }
      );
    } else if (option.id === this.constants.switchPurchases.id) {
      this.timeSwitchSelected = this.constants.switchPurchases;
      this.show = "purchases";
      // this.fetchPurchaseList();
    } else if (option.id === this.constants.switchBudgets.id) {
      this.timeSwitchSelected = this.constants.switchBudgets;
      this.show = "budgets";
    } else if (option.id === this.constants.switchFiscalDataExtension.id) {
      this.timeSwitchSelected = this.constants.switchFiscalDataExtension;
      this.show = "fiscalDataExtensions";
    } else if (option.id === this.constants.switchBills.id) {
      this.timeSwitchSelected = this.constants.switchBills;
      this.show = "clientBills";
    } else if (option.id === this.constants.switchPaymentMethods.id) {
      this.timeSwitchSelected = this.constants.switchPaymentMethods;
      this.show = "pagoAplazado";
    }

    this.pushQueryStrings();
  }

  private fetchTagList() {
    this.$store.dispatch("fetchClientTagList").then((res) => {
      this.clientTagList = res.map((e: any) => {
        return {
          active: false,
          name: e.name,
          id: e.id,
        };
      });

      this.client.tag.forEach((element, index) => {
        if (!this.client.tag[index].isActive) {
          this.clientTagList.push(element)
        }
      });

    });
  }

  private fetchProvinceList() {
    this.$store.dispatch("fetchClientProvinceList").then((res) => {
      this.clientProvinceList = res.map((e: any) => {
        const option = {
          value: e.name,
          label: e.name,
        };
        return option;
      });
      this.updateKey++;
    });
  }

  private fetchCountryList() {
    this.$store.dispatch("fetchClientCountryList").then((res) => {
      this.clientCountryList = res.map((e: any) => {
        const option = {
          value: e.name,
          label: e.name,
        };
        return option;
      });
      this.updateKey++;
    });
  }

  private toggleClientObservationModalOpened(value: boolean) {
    // sendNotifications(note.id)
    // ENVIAR this.employeeEmails AL BACK
    this.addObservationClientModalOpened = value;
  }

  private toggleCommentModalOpened(value: boolean) {
    this.addCommentModalOpened = value;
  }

  private addComment(noteId: any, element: any, type: any) {
    let helper
    if (type == 'budget') {
      helper = element.uid;
    } else {
      helper = element.participantId;
    }
    if (this.modalComment.length === 0) {
      this.modalCommentEmpty = true;
    } else {
      this.addCommentModalOpened = false;
      // this.requestShowSpinner();
      this.$store
        .dispatch("newBudgetCommentNote", {
          elementId: type == "budget" ? element.uid : element.participantId,
          noteId: noteId,
          employee: { user: { id: this.getProfile.id } },
          comment: this.modalComment,
        })
        .then((res) => {
          if (type == 'budget') {
            // this.activeBudgetNote = "";
            this.fetchBudgetsList();
          } else {
            // this.activeNote = "";
            console.log(this.activeNote);
            this.fetchCoursesList();
          }
          // setTimeout(() => {
          //   setTimeout(() => {
          //     if(type == 'budget'){
          //       this.activeBudgetNote = element.uid;
          //     } else {
          //       this.activeNote = element.participantId;
          //     }
          //   }, 500);
          // }, 0);
          // this.$emit( 'comment-note-item-delete' );
          // this.resetModalNoteEmpty(true);
          // this.fetchBudgetNotes(this.elementId);
          // // this.changeSpinnerVisibility(false);
          // this.refetchBudget(this.elementId);
        });
    }
  }

  private fetchPostalCodeList(province: any) {
    this.$store.dispatch("fetchClientPostalCodeList", /* province */).then((res) => {
      this.clientPostalCodeList = res.map((e: any) => {
        const option = {
          value: e.name || '',
          label: e.name || '',
          province: e.province? e.province.name: '',
          country: e.province && e.province.country ? e.province.country.name : ''
        };
        return option;
      });
    });
  }

  private deleteNote(noteId: string, participant: any) {
    const payload = {
      participantId: participant.participantId,
      noteId,
    };
    this.$store.dispatch('removeParticipantNote', payload);
    this.fetchCoursesList();
    // setTimeout(() => {
    //   this.activeNote = "";
    //   setTimeout(() => {
    //     this.activeNote = participant.participantId;
    //   }, 2000);
    // }, 0);
  }

  private updateNote(noteId: string, noteContent: string, participant: any) {
    const payload = {
      participantId: participant.participantId,
      // participantId: participant.participant.id,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id },
    };
    this.$store.dispatch("patchParticipantNote", payload);

    // this.fetchCoursesList();

    // setTimeout(() => {
    //   this.activeNote = "";
    //   setTimeout(() => {
    //     this.activeNote = participant.participantId;
    //   }, 2000);
    // }, 0);
  }

  private ticketUrl(participant:any) {
    let url = '';
    const baseUrl = `${process.env.VUE_APP_BASE_URI_API}${Endpoints.participant
      }`;
    url = `${baseUrl}${participant.participantId}/ticket`;
    return url;
  }

  private ticketTooltipTitle(participant:any) {
    let title = 'Entrada no descargada';
    if (participant.ticketDownloaded) {
      title = 'Ver entrada';
    }
    return title;
  }

  private moveToList(val: any, participant:any) {
    if (ParticipantListType.ParticipantList === this.listType) {
      this.$store
        .dispatch('moveToWaitingList', { participantId: participant.participantId })
        .then(
          (res) => {
            this.fetchCoursesList();
          },
          (err) => {
            this.emitMessageError(err.response);
          },
        );
    } else if (
      ParticipantListType.WaitingList === this.listType ||
      ParticipantListType.RepeaterList === this.listType
    ) {
      this.$store
        .dispatch('moveToParticipantList', {
          participantId: participant.participantId,
        })
        .then(
          (res) => {
            this.$emit('refetch-list', true);
          },
          (err) => {
            this.emitMessageError(err.response);
          },
        );
    }
  }

  private emitMessageError(response: any) {
    if (response.data && response.data.detail) {
      this.$emit('show-message', response.data.detail);
    }
  }

  private updateBudgetNote(noteId: string, noteContent: string, budget: any) {
    const payload = {
      budgetId: budget.uid,
      // participantId: participant.participant.id,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id },
    };
    this.$store.dispatch("patchBudgetNote", payload);

    // this.fetchBudgetsList();

    // setTimeout(() => {
    //   this.activeBudgetNote = "";
    //   setTimeout(() => {
    //     this.activeBudgetNote = budget.uid;
    //   }, 2000);
    // }, 0);
  }

  private updatePurchaseNote(noteId: string, noteContent: string, purchase: any) {
    const payload = {
      purchaseId: purchase.uid,
      // participantId: participant.participant.id,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id },
    };
    this.$store.dispatch("patchPurchaseNote", payload);

    // this.fetchPurchasesList();

    // setTimeout(() => {
    //   this.activePurchaseNote = "";
    //   setTimeout(() => {
    //     this.activePurchaseNote = purchase.uid;
    //   }, 2000);
    // }, 0);
  }

  private deleteBudgetNote(noteId: string, budget: any) {
    const payload = {
      id: noteId,
      noteId,
    };
    this.$store.dispatch('removeBudgetNote', payload);
    this.fetchBudgetsList();
    // setTimeout(() => {
    //   this.activeBudgetNote = "";
    //   setTimeout(() => {
    //     this.activeBudgetNote = budget.uid;
    //   }, 2000);
    // }, 0);
  }

  private deletePurchaseNote(noteId: string, purchase: any) {
    const payload = {
      id: noteId,
      noteId,
    };
    this.$store.dispatch('removePurchaseNote', payload);
    this.fetchPurchasesList();
    // setTimeout(() => {
    //   this.activePurchaseNote = "";
    //   setTimeout(() => {
    //     this.activePurchaseNote = purchase.uid;
    //   }, 2000);
    // }, 0);
  }

  private refreshNotes(participantId: string) {
    this.fetchCoursesList();
    // setTimeout(() => {
    //   this.activeNote = "";
    //   setTimeout(() => {
    //     this.activeNote = participantId;
    //   }, 2000);
    // }, 0);
  }

  private refreshBugetNotes(uid: string) {
    this.fetchBudgetsList();
    // setTimeout(() => {
    //     this.activeBudgetNote = "";
    //     setTimeout(() => {
    //       this.activeBudgetNote = uid;
    //     }, 2000);
    //   }, 0);
  }

  private refreshPurchaseNotes(uid: string) {
    this.fetchPurchasesList();
    // setTimeout(() => {
    //     this.activePurchaseNote = "";
    //     setTimeout(() => {
    //       this.activePurchaseNote = uid;
    //     }, 2000);
    //   }, 0);
  }

  private checkUser(note: any) {
    return (
      note.employee &&
      note.employee.user &&
      this.getProfile.id === note.employee.user.id
    );
  }

  private checkMandatoryFields() {
    let result = true;
    if (this.client.user) {
      if (this.client.user.firstName === "") {
        this.error.user.firstName = "Campo vacío";
        result = false;
      }
      if (this.client.user.lastName === "") {
        this.error.user.lastName = "Campo vacío";
        result = false;
      }
      if (this.client.user.email === "") {
        this.error.user.email = "Campo vacío";
        result = false;
      }
      // if (
      //   (Object.keys(this.client.user.profile).length === 0 &&
      //     this.client.user.profile.constructor === Object) ||
      //   this.client.user.profile.phone === "" ||
      //   this.client.user.profile.phone === null
      // ) {
      //   this.error.user.profile.phone = "Campo vacío";
      //   result = false;
      // }
    }
    return result;
  }

  private topBarScrolled(scrolled: boolean) {
    this.alertDisplace = scrolled;
  }

  private setClientFormError(err: any) {
    const serverError = err.response.data;
    this.error = { ...this.error, ...serverError };
    if (err.response.status === 500) {
      this.showNotification(
        Constants.internalServerErrorMessage,
        SpotlightTextColor.Secondary
      );
    }
  }

  private deleteClient() {
    this.$store.dispatch("deleteClient", { id: this.id }).then((res) => {
      this.deleteModalToggle(false);
      this.showNotification("Cliente eliminado con éxito");
      setTimeout(() => {
        this.$router.push({ name: "clientList" });
      }, 2000);
    });
  }

  private deleteModalToggle(value: boolean) {
    this.isDeleteModalOpened = value;
  }

  private trainerAvatar(clientProduct: ClientProduct) {
    let avatar = clientProduct.avatarTrainer;
    if (!avatar) {
      avatar = Assets.defaultAvatar;
    }
    return avatar;
  }

  private isDisabled(participant: ClientParticipants) {
    return participant.out || participant.postpone;
  }

  private isDisabledPurchase(purchase: any) {
    return purchase.requestReturn != 1;
  }

  private isDisabledFiscalDataExtension(fiscalDataExtension: any) {
    return fiscalDataExtension.isDefault;
  }

  private isRepeater(clientProduct: ClientProduct) {
    return clientProduct.repeater;
  }

  private toggleBudgetNoteObservationModalOpened(value: boolean, element?: any) {
    if (element) {
      if (element.requestReturn) {
        this.activePurchaseNote = element.uid;
      } else {
        this.activeBudgetNote = element.uid;
      }
    }
    this.addObservationBudgetNoteModalOpened = value;
  }

  private toggleConvocationNoteObservationModalOpened(participantId?: any) {
    if (participantId) {
      this.activeNote = participantId
    }
    this.addObservationBudgetNoteModalOpened = true;
  }

  private togglePurchaseNoteObservationModalOpened(purchaseId?: any) {
    if (purchaseId) {
      this.activePurchaseNote = purchaseId
    }
    this.addObservationBudgetNoteModalOpened = true;
  }

  private toggleBudgetNewNoteObservationModalOpened(budgetId?: any) {
    if (budgetId) {
      this.activeBudgetNote = budgetId
    }
    this.addObservationBudgetNoteModalOpened = true;
  }

  private addNote() {
    if (this.modalNote.length === 0) {
      this.modalNoteEmpty = true;
    } else {
      this.addObservationBudgetNoteModalOpened = false;
      // this.requestShowSpinner();
      this.$store
        .dispatch("newParticipantNote", {
          participantId: this.activeNote,
          employee: { user: { id: this.getProfile.id } },
          note: this.modalNote,
        })
        .then((res) => {
          // this.fetchAcquiredCourses();
          this.fetchCoursesList();
          // setTimeout(() => {
          //   this.activeNote = "";
          //   setTimeout(() => {
          //     this.activeNote = participant.convocationId;
          //   }, 2000);
          // }, 0);

        });
    }
  }

  private addBudgetNote() {
    if (this.modalNote.length === 0) {
      this.modalNoteEmpty = true;
    } else {
      this.addObservationBudgetNoteModalOpened = false;
      // this.requestShowSpinner();
      this.$store
        .dispatch("newBudgetNote", {
          budgetId: this.activeBudgetNote,
          employee: { user: { id: this.getProfile.id } },
          note: this.modalNote,
        })
        .then((res) => {
          this.fetchBudgetsList();
          // setTimeout(() => {
          //   this.activeBudgetNote = "";
          //   setTimeout(() => {
          //     this.activeBudgetNote = this.activeBudgetNote;
          //   }, 2000);
          // }, 0);

        });
    }
  }

  private addPurchaseNote() {
    if (this.modalNote.length === 0) {
      this.modalNoteEmpty = true;
    } else {
      this.addObservationBudgetNoteModalOpened = false;
      // this.requestShowSpinner();
      this.$store
        .dispatch("newPurchaseNote", {
          purchaseId: this.activePurchaseNote,
          employee: { user: { id: this.getProfile.id } },
          note: this.modalNote,
        })
        .then((res) => {
          this.fetchPurchasesList();
          // setTimeout(() => {
          //   this.activePurchaseNote = "";
          //   setTimeout(() => {
          //     this.activePurchaseNote = purchase.uid;
          //   }, 2000);
          // }, 0);

        });
    }
  }

  private fetchRefundedOriginBill(billId: any) {
    this.$store.dispatch('fetchRefundedOriginBill', { id: billId }).then(
      res => {
        if (res.originBill) {
          return false
        } else if (res.refundedBill) {
          return true
        }
      }
    );
  }

  get modalNotePlaceholder() {
    let placeholder =
      "Comparte alguna nota con tus compañeros sobre esta alta...";
    if (this.modalNoteEmpty) {
      placeholder = "Este campo no puede estar vacío...";
    }
    return placeholder;
  }

  private patchClient(data: any) {
    const payload = {
      id: this.id,
      data,
    };
    this.$store.dispatch("patchClient", payload).then((res) => {
      this.showNotification("Cliente editado con éxito");
    });
  }

  private parseProcedencyToFlatSelectorTextOption(procedencyList: any) {
    this.procedencyOptionsRequest = procedencyList.map((procedency: any) => {
      const option = {
        value: procedency.id,
        label: procedency.name,
      };
      return option;
    });
  }

  private fetchProcedency() {
    this.$store.dispatch("fetchProcedency").then((res) => {
      this.parseProcedencyToFlatSelectorTextOption(this.getProcedencyList);
    });
  }

  // private patchParticipant(data: any, type) {
  //   data[type] = !data[type];

  //   const payload = {
  //     participantId: data.participantId,
  //     data,
  //   };

  //   this.$store.dispatch("patchConvocationParticipant", payload).then((res) => {
  //     this.fetchAcquiredCourses();
  //     // this.fetchConvocationHeaders();
  //     // this.fetchParticipantLog();
  //   });
  // }

  private fetchParticipantNotes(data: any) {
    if (this.globalConferencias == false || this.globalCursos == false || this.globalEventos == false) {
      if (this.activeNote == data.participantId) {
        this.activeNote = "";
      } else {
        this.activeNote = data.participantId;
      }
    }
    // this.$store
    //   .dispatch('fetchParticipantNotes', { participantId: data.participantId })
    //   .then((res) => {
    //     this.notes = res;
    //     console.log(res);
    //   });
  }

  private fetchBudgetNotes(data: any) {
    if (this.globalPresupuestos == false) {
      if (this.activeBudgetNote == data) {
        this.activeBudgetNote = "";
      } else {
        this.activeBudgetNote = data;
      }
    }
    // this.$store
    //   .dispatch('fetchParticipantNotes', { participantId: data.participantId })
    //   .then((res) => {
    //     this.notes = res;
    //     console.log(res);
    //   });
  }

  private fetchPurchaseNotes(data: any) {
    if (this.globalPurchase == false) {
      if (this.activePurchaseNote == data) {
        this.activePurchaseNote = "";
      } else {
        this.activePurchaseNote = data;
      }
    }
    // this.$store
    //   .dispatch('fetchParticipantNotes', { participantId: data.participantId })
    //   .then((res) => {
    //     this.notes = res;
    //     console.log(res);
    //   });
  }

  private emitDelete() {
    this.$emit('note-item-delete', this.note.id);
  }

  get paymentStatusOptions() {
    const options = [];
    for (const paymentStatus in BudgetPaymentStatus) {
      if (Number(paymentStatus) >= 0) {
        options.push({
          value: paymentStatus,
          label: BudgetPaymentStatusLiteral[paymentStatus],
          colorSelected: this.paymentStatusColor(Number(paymentStatus)),
        });
      }
    }
    return options;
  }

  private onChangeStatus(event: any, id: any) {
    this.patchBudget(event.value, id)
  }

  private patchBudget(data: any, id: any) {
    data = { 'payment_status': data };
    const payload = {
      id,
      data,
    };
    this.$store.dispatch('patchBudget', payload);
  }

  private paymentStatusOptionSelected(status: any) {
    return this.paymentStatusOptions.find((option) => {
      return option.value === status.toString();
    });
  }

  private paymentStatusColor(paymentStatus: number) {
    let color = '';
    if (paymentStatus === BudgetPaymentStatus.Cancelled) {
      color = 'red';
    } else if (
      paymentStatus === BudgetPaymentStatus.Completed ||
      paymentStatus === BudgetPaymentStatus.InProgress
    ) {
      color = 'primary';
    }
    return color;
  }

  private emitShowMessage(message: string, error: boolean = false) {
    this.$emit('show-message', { message, error });
  }

  private onError() {
    this.emitShowMessage(Constants.internalServerErrorMessage, true);
  }
  private onSucess() {
    this.emitShowMessage('Email envíado correctamente');
  }


  private sendDocumentEmail(id: any) {
    PurchaseService.sendPurchaseDocument(id, {})
      .then((res) => { this.$emit("show-message", res.data.details) })
  }

  private sendDocumentBillEmail(id: any) {
    BillingService.sendBillEmail(id)
      .then(this.onSucess, this.onError);
  }

  private seeDocument(url: any) {
    window.open(url, '_blank');
  }

  private setRequestReturn(status: any, id: any) {
    // this.purchase.requestReturn = status;
    let data = { 'request_return': status };
    this.patchPurchase(data, id);
  }

  private setEnrolled(status: any, id: any) {
    let data = { 'enrolled': status, 'activated': new Date().toISOString(), 'activatedBy': this.getProfile.id };
    this.patchPurchase(data, id);
  }

  // private setIsPostponement(id:any, note:any, isPostponement:any) {
  //       // this.purchase.requestReturn = status;
  //       console.log(isPostponement);
  //       this.$emit( 'note-item-update', id, note, isPostponement );
  //   }


  private setIsPostponement(element: any, noteId: string, noteContent: string, isPostponement?: string) {
    const payload = {
      participantId: element.participantId,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id, isPostponement: isPostponement },
    };
    this.$store.dispatch('patchParticipantNote', payload);
    this.activeNote = "";
    this.fetchAcquiredCourses();
    setTimeout(() => {
      setTimeout(() => {
        this.activeNote = element.participantId;
      }, 2000);
    }, 0);
  }

  private setIsDefault(element: any, noteId: string, noteContent: string, isPostponement?: string) {
    const payload = {
      participantId: element.participantId,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id, isPostponement: isPostponement },
    };
    this.$store.dispatch('patchParticipantNote', payload);
    this.activeNote = "";
    this.fetchAcquiredCourses();
    setTimeout(() => {
      setTimeout(() => {
        this.activeNote = element.participantId;
      }, 2000);
    }, 0);
  }

  private setIsBudgetPostponement(element: any, noteId: string, noteContent: string, isPostponement?: string) {
    const payload = {
      budgetId: element.uid,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id, isPostponement: isPostponement },
    };
    this.$store.dispatch('patchBudgetNote', payload);
    this.activeBudgetNote = "";
    this.fetchBudgetsList();
    setTimeout(() => {
      setTimeout(() => {
        this.activeBudgetNote = element.uid;
      }, 2000);
    }, 0);
  }

  private setIsPurchasePostponement(element: any, noteId: string, noteContent: string, isPostponement?: string) {
    const payload = {
      purchaseId: element.uid,
      noteId,
      data: { note: noteContent, employeeModified: this.getProfile.id, isPostponement: isPostponement },
    };
    this.$store.dispatch('patchPurchaseNote', payload);
    this.activePurchaseNote = "";
    this.fetchPurchasesList();
    setTimeout(() => {
      setTimeout(() => {
        this.activePurchaseNote = element.uid;
      }, 2000);
    }, 0);
  }

  private refreshComments(commentId: any, comment: any) {
    // setTimeout(() => {
    //   this.fetchAcquiredCourses();
    // }, 2000);
  }

  private patchFiscalDataExtension(data: any, userId: any, id: any) {
    data = { 'isDefault': data };
    const payload = {
      id,
      userId,
      data,
    };
    this.$store.dispatch('patchFiscalDataExtension', payload);
    setTimeout(() => {
      this.fetchFiscalDataExtensionsList();
    }, 1000);
    // 2000
  }

  private patchPurchase(data: any, id: any) {
    const payload = {
      id,
      data,
    };
    this.$store.dispatch('patchPurchase', payload);
    setTimeout(() => {
      this.fetchAcquiredCourses();
    }, 2000);
  }

  private sendFormIcon() {
    const newClient = this.client;
    let clientIcons = {
      'user': this.client.user,
      'topLevelPack': newClient.topLevelPack,
      'merchandising': newClient.merchandising,
      'powerPack': newClient.powerPack,
      'powerPackMerchandising': newClient.powerPackMerchandising
    }
    if (this.isEdit) {
      this.patchClient(clientIcons)
    }
  }

  private sendForm() {
    if (!(this.client.user as any).profile.phone || (this.client.user as any).profile.phone == "+") {
      (this.client.user as any).profile.phone = 'SIN DATOS';
    } else {
      (this.client.user as any).profile.phone = (this.client.user as any).profile.phone.replaceAll(/\s/g, '');
    }
    const newClient = this.client;
    (newClient as any).note = { note: this.lastNoteTyped };
    if (this.checkMandatoryFields()) {
      if ((newClient.user as any).profile.birthday === "") {
        delete (newClient.user as any).profile.birthday;
      }
      if (this.isEdit) {
        if (!newClient.tlp) {
          delete newClient['tlp']
        }
        (newClient.user as any).id = this.id;
        this.$store
          .dispatch("updateClient", {
            id: this.id,
            newClient,
          })
          .then((res) => {
            this.showNotification("Cliente editado con éxito");
          })
          .catch((err) => {
            this.setClientFormError(err);
          });
      } else {
        this.$store
          .dispatch("newClient", {
            newClient,
          })
          .then((res) => {
            this.$router.push({
              name: this.$router.currentRoute.name,
              params: { id: res.user.id },
            });
            this.updated = true;
            this.showNotification("Cliente creado con éxito");
          })
          .catch((err) => {
            this.setClientFormError(err);
          });
      }
    }
  }

  private openConferencias() {
    this.globalConferencias = !this.globalConferencias;
  }

  private openCursos() {
    this.globalCursos = !this.globalCursos;
  }

  private openEventos() {
    this.globalEventos = !this.globalEventos;
  }

  private openPresupuestos() {
    this.globalPresupuestos = !this.globalPresupuestos;
  }

  private openPurchase() {
    this.globalPurchase = !this.globalPurchase;
  }

  private patchParticipant(data: any, type: any, status?: any) {
    if (type == "out") {
      data[type] = status;
    } else {
      data[type] = !data[type];
    }

    const payload = {
      participantId: data.participantId,
      data,
    };

    this.$store.dispatch("patchConvocationParticipant", payload).then((res) => {
      this.fetchAcquiredCourses();
      // this.fetchConvocationHeaders();
      // this.fetchParticipantLog();
    });
  }

  private openFiscalData() {
    window.open("/api/admin/users/user/" + this.client.user.id, '_blank');
  }

  // private addFiscalData() {
  //     const billToEdit = Object.assign({}, this.bill);
  //     billToEdit.billLine = Object.assign([], this.bill.billLine);
  //     console.log(billToEdit)
  //     this.setCurrentFiscalDat(billToEdit);
  //     this.$emit('edit-bill');
  // }

  private setaddFiscalDataModalOpened(value: boolean) {
    this.addFiscalDataModalOpened = value;
  }

  private setAddClientPaymentOpened(value: boolean) {
    this.addClientPaymentModalOpened = value;
    this.setCurrentBudget(new Budget());
  }

  private setEditFiscalDataModalOpened(value: boolean) {
    this.editFiscalDataModalOpened = value;
  }

  private setEditable(value: boolean, fiscalDataExtension: any) {
    this.editingFiscalData = value;
    this.fiscalDataEdit = fiscalDataExtension;
    this.setEditFiscalDataModalOpened(true);
  }

  get openModal() {
    return this.addClientPaymentModalOpened || this.editFiscalDataModalOpened;
  }

  private closingModal() {
    this.editingFiscalData = false;
    this.fetchFiscalDataExtensionsList();
    this.setEditFiscalDataModalOpened(false);
    this.setAddClientPaymentOpened(false);
  }

  private setProvince() {
    setTimeout(() => {
      let result = this.clientPostalCodeList.find((option: any) => {
        if(this.client.user.profile.postalCode){
          return option.value.slice(0, 2) === this.client.user.profile.postalCode.slice(0, 2);
        }
      });

      if (this.client.user.profile.postalCode && this.client.user.profile.postalCode.length == 5) {
        let zipCodesResults = this.zipcodes.filter((zipcode:any) => zipcode.zipcode === this.client.user.profile.postalCode);
        if (zipCodesResults.length>0) {
          this.client.user.profile.town = zipCodesResults[0].place
        }
      }

      if (result) {
        this.client.user.profile.country = result.country;
        this.client.user.profile.state = result.province;
      }
    }, 1000);
  }

  private fetchClientPayment(viewStatus: number) {
    this.$store
      .dispatch("fetchClientPayment", { id: this.id, viewStatus: viewStatus })
      .then((res) => {
        this.clientPayments = res.data
        if (res.info != '') {
          this.showNotification(res.info, SpotlightTextColor.Error);
        }
        this.$forceUpdate();
      });
  }

  private updateClientPayment(newVal: any, inactive:any=false) {
    newVal.inactive = inactive
    this.$store
      .dispatch("updateClientPayment", { id: this.id, viewStatus: 0, ...newVal })
      .then((res) => {
        if (res.message != '') {
          this.showNotification(res.message);
          this.fetchClientPayment(0)
        }
      })
      .catch((err) => {
        this.showNotification(err.error, SpotlightTextColor.Error);
      });
  }

  get creditCardFormated() {
    const creditCard = Object.assign({}, this.currentBudget.creditCard);
    const splittedDate = creditCard.dateExpiration.split('/');
    const month = Number(splittedDate[0]) - 1;

    let dateDayjs = dayjs();
    let year = dateDayjs.year().toString();
    year = year.substring(0, year.length - 2);
    year += splittedDate[1];
    dateDayjs = dateDayjs
      .set('date', 1)
      .set('month', month)
      .set('year', Number(year));
    creditCard.dateExpiration = dateDayjs.toISOString();

    return creditCard;
  }

  private getPaymentInfo() {
    let info = {};
    if (this.isCardMethodSelected) {
      info = { creditCard: this.creditCardFormated };
    } else if (this.isDirectDebitMethodSelected) {
      // const bankId = this.currentBudget.bankAccount.bank.id;
      // this.currentBudget.bankAccount.bank = bankId;
      if (process.env.VUE_APP_DEBUG) {
        // this.currentBudget.bankAccount.bank = "572a9108-f910-4cb6-942c-cedb529e29e3";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      } else {
        // this.currentBudget.bankAccount.bank = "7591c2a8-691c-4862-aa57-fc374e9117a2";
        this.currentBudget.bankAccount.bank = "ec3215aa-a207-457a-865b-dca79c864263";
      }
      info = { bankAccount: this.currentBudget.bankAccount };
    }
    return info;
  }

  private cleanCurrentBudget(){
    this.currentBudget.creditCard = undefined
    this.currentBudget.bankAccount = undefined
  }

  private addPaymentInfo() {
    if (this.checkFormValidation()) {
      let errorNotification = null;
      let holder = null;

      if (this.isCardMethodSelected) {
        holder = this.currentBudget.creditCard.holder;
      } else if (this.isDirectDebitMethodSelected) {
        holder = this.currentBudget.bankAccount.holder;
      }

      if (holder && this.client.user.fullName !== holder) {
        errorNotification = "El nombre del titular ha de ser igual al NOMBRE del cliente actual";
      }

      if (errorNotification) {
        this.showNotification(errorNotification, SpotlightTextColor.Error);
      } else {
        this.$store
          .dispatch("newClientPayment", { id: this.id, viewStatus: 0, ...this.getPaymentInfo() })
          .then((res) => {
            this.setAddClientPaymentOpened(false)
            this.fetchClientPayment(0)
            this.cleanCurrentBudget()
          })
          .catch((err) => {
            this.showNotification(err, SpotlightTextColor.Error);
          });
      }
    }
  }

  private checkFormValidation() {
    if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()
    ) {
      return this.directDebitFieldsValidation();
    } else if (
      this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()
    ) {
      return this.cardFieldsValidation();
    }
  }

  private directDebitFieldsValidation() {
    if (this.currentBudget.bankAccount) {
      const error: any = { bankAccount: {}, budgetSepaInfo: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores =false
      // if (!(this.currentBudget.bankAccount as any).bank) {
      //   error.bankAccount['bank'] = emptyField;
      // }
      const bankNumber = (this.currentBudget.bankAccount as any).number;
      if (!bankNumber) {
        error.bankAccount['number'] = emptyField;
        errores=true
      } else if (bankNumber.trim().length < 24) {
        error.bankAccount['number'] = errorField;
        errores=true
      }
      if (!(this.currentBudget.bankAccount as any).holder) {
        error.bankAccount['holder'] = emptyField;
        errores=true
      }
      if (!(this.currentBudget.bankAccount as any).number) {
        error.bankAccount['number'] = emptyField;
        errores=true
      }
      
      if(errores){
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private cardFieldsValidation() {
    if (this.currentBudget.creditCard) {
      const error: any = { creditCard: {} };
      const emptyField = 'Campo vacío';
      const errorField = 'Campo incorrecto';
      var errores = false

      const cardNumber = (this.currentBudget.creditCard as any).number;
      if (!cardNumber) {
        error.creditCard['number'] = emptyField;
        errores=true
      } else if (cardNumber.trim().length < 16) {
        error.creditCard['number'] = errorField;
        errores=true
      }
      const dateExpiration = (this.currentBudget.creditCard as any)
        .dateExpiration;
      if (!dateExpiration) {
        error.creditCard['dateExpiration'] = emptyField;
        errores=true
      } else if (dateExpiration.trim().length < 5) {
        error.creditCard['dateExpiration'] = errorField;
        errores=true
      }
      const cvv = (this.currentBudget.creditCard as any).cvv;
      if (!cvv) {
        error.creditCard['cvv'] = emptyField;
        errores=true
      } else if (cvv.trim().length < 3) {
        error.creditCard['cvv'] = errorField;
        errores=true
      }
      if (!(this.currentBudget.creditCard as any).holder) {
        error.creditCard['holder'] = emptyField;
        errores=true
      }

      if(errores){
        this.setAcceptanceFieldError(error);
        return false
      } else {
        return true
      }
    }
  }

  private setAcceptanceFieldError(error: any) {
    const newError = error;
    this.$store.commit('setAcceptanceFieldError', newError);
  }

  private copyHolderName() {
    if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.DirectDebit.toString()) {
      this.currentBudget.bankAccount.holder = this.client.user.fullName
    } else if (this.currentBudget.paymentMethod.toString() ===
      BudgetPaymentMethod.Card.toString()) {
      this.currentBudget.creditCard.holder = this.client.user.fullName
    }

    this.setCurrentBudget(this.currentBudget)

  // Forzar refresco de los componentes hijos
    const choosePaymentMethodComponent = this.$refs.componentePagoAplazado as ChoosePaymentMethod
    if (choosePaymentMethodComponent.$children) {
      choosePaymentMethodComponent.$children.forEach((child:any) => {
        child.$forceUpdate()
      });
    }

  }
}
